import React, { useState } from "react";
import axios from "axios";

const UpdateLicense = () => {
  const [form, setForm] = useState({
    license_key: "",
    status: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const updateLicense = async () => {
    try {
      await axios.post(
        "https://streamsrvbac.n-tools.info/keymanage/license/update",
        form
      );

      alert("License updated successfully");
    } catch (err) {
      alert("Update failed");
    }
  };

  return (
    <div style={{ padding: 20, color: "white" }}>
      <h2>Update License</h2>

      <input
        name="license_key"
        placeholder="License Key"
        onChange={handleChange}
      />

      <select name="status" onChange={handleChange}>
        <option value="">Select Status</option>
        <option value="active">Active</option>
        <option value="suspended">Suspended</option>
        <option value="expired">Expired</option>
        <option value="inactive">Inactive</option>
      </select>

      <button onClick={updateLicense}>Update</button>
    </div>
  );
};

export default UpdateLicense;
